export default "__VITE_ASSET__Y383QUYM__"